import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import { apiClient } from '@services/api';

const GreenRedSwitch = withStyles({
  switchBase: {
    color: '#ef4444',
    '&$checked': {
      color: '#22c55e',
    },
    '&$checked + $track': {
      backgroundColor: '#22c55e',
      opacity: 0.5,
    },
  },
  track: {
    backgroundColor: '#ef4444',
    opacity: 0.5,
  },
  checked: {},
})(Switch);

/**
 * StatusSwitch — toggle verde (ativo) / vermelho (inativo)
 *
 * Props:
 *   status   {boolean}  estado inicial
 *   url      {string}   endpoint PUT para atualizar status  ex: "translados/values/5/status"
 *   field    {string}   campo enviado no body (padrão: "status")
 *   onChange {function} callback opcional (newStatus) => void
 */
const StatusSwitch = ({ status: initialStatus, url, field = 'status', onChange }) => {
  const [status, setStatus] = useState(!!initialStatus);
  const [loading, setLoading] = useState(false);

  const handleChange = () => {
    setLoading(true);
    apiClient.httpInstance.put(url, { [field]: !status })
      .then((response) => {
        const newStatus = typeof response.data === 'boolean' ? response.data : !status;
        setStatus(newStatus);
        if (onChange) onChange(newStatus);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex items-center">
      {loading && <CircularProgress size={15} className="mr-1" />}
      <GreenRedSwitch
        checked={status}
        onChange={handleChange}
        inputProps={{ 'aria-label': 'status switch' }}
      />
    </div>
  );
};

export default StatusSwitch;
